import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 네비게이션 레이아웃에 따른 body 클래스 업데이트 커스텀 훅
 * /alliance 경로에서는 nav-layout 클래스를 적용하지 않음 (AllianceSidebar 사용)
 */
export const useNavLayoutClass = (navLayout) => {
  const location = useLocation();

  useEffect(() => {
    // /alliance 경로에서는 nav-layout 클래스를 적용하지 않음
    if (location.pathname.startsWith('/alliance')) {
      document.body.classList.remove('nav-layout-top', 'nav-layout-left', 'nav-layout-right');
      return;
    }

    document.body.classList.remove('nav-layout-top', 'nav-layout-left', 'nav-layout-right');
    document.body.classList.add(`nav-layout-${navLayout}`);
  }, [navLayout, location.pathname]);
};
